<template>
  <div name="outcomeapply">
    <div class="mb-2 p-2 pb-10 h-16 pr-0 bg-gray-200 border-t">
      <dropdown
        v-if="sectionList.length > 0"
        :options="outcomeSectionsDropdown"
        :selected="selectedTab"
        v-on:updateOption="updateSelectedTab"
        class="w-56 ml-4 bg-white text-center"
      >
        ></dropdown
      >
    </div>

    <div
      style="width: 100%; text-align: center"
      class="spin-holder mt-4"
      v-if="loading"
    >
      <i class="spinner fa fa-spinner fa-spin"></i>
      <p>Loading Outcomes</p>
    </div>

    <section v-if="errored" class="w-full text-center mt-2">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the outcome details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <template v-else>
      <table
        class="table-wrapper w-full bg-white mx-auto rounded shadow-sm mb-20"
      >

        <tbody
           v-for="(section, index) in outcomeSections" :key="index"
          class="mb-10"
        >
          <tr class="py-4">
            <td colspan="2" class="text-sm uppercase font-bold">
              <div class="pl-4 pt-6 block">
                {{ section.value }} ({{
                  outcomesOrderedBySectionCount(section)
                }})
              </div>
            </td>
          </tr>
      
          <tr 
            v-for="(item, index) in outcomesOrderedBySection(section.key)"
            :key="index"
            class="course list-complete-item"
            v-bind:class="isSchoolType(item) ? 'text-pink-red' : ''"
          >
            <td class="w-10/12 text-xs">
              <span class="pl-4">{{ item.title }}</span>
            </td>
            <td class="w-1/12 -pr-2">
              <div
                v-if="item.unit_only === 1 && item.type_id === 1"
                class="text-center text-gray-600 my-1 mr-1"
              >
                <i
                  class="text-sm pt-2 fas fa-check opacity-50 text-green-700"
                ></i>
              </div>
              <div
                v-else-if="item.unit_only === 0"
                class="text-center my-1 ml-4 rounded-xl bg-action-blue bg-opacity-25 w-10 h-8"
              >
                <i class="text-sm pt-2 fas fa-check opacity-75 text-white"></i>
              </div>
              <div class="text-center" v-else>
                <button
                  type="button"
                  @click="selectOutcome(item)"
                  class="rounded-xl my-1 mr-1 w-10 h-8 cursor-pointer focus:outline-none hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
                  v-bind:class="[
                    containsOutcome(item)
                      ? 'bg-action-blue bg-opacity-75 text-white'
                      : 'bg-gray-200 text-gray-600',
                  ]"
                >
                  <i
                    class="text-base far"
                    v-bind:class="
                      containsOutcome(item) ? 'fa-check-circle' : 'fa-circle'
                    "
                  ></i>
                </button>
              </div>
            </td>
          </tr>

 
  <tr>
            <td colspan="2">
              <div class="flex flex-wrap">
                <div
                  @click="addCustomeOutcome(section)"
                  class="w-1/12 pl-4 pt-2 text-center text-2xl cursor-pointer text-blue-400 hover:opacity-50"
                >
                  <i class="fas fa-plus-circle pr-1 text-black"></i>
                </div>
                <div class="w-2 py-4 mx-3 text-sm">OR</div>

                <div class="w-9/12 px-3">
                  <input
                    @input="addNewValue(section, $event.target.value)"
                    class="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-200 rounded h-10 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-title"
                    type="text"
                    placeholder="Enter new outcome"
                    required=""
                  />
                </div>
                <div
                  class="w-1/12 py-4 text-right text-sm cursor-pointer hover:opacity-50"
                >
                  <a @click="addOutcomeFromText(section)">Add new</a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>

      </table>
    </template>

    <div v-show="showOutcomeSelection">
      <transition name="slidesecond">
        <div class="">
          <div class="sidesecond sm:w-full md:w-3/4" v-on:click.prevent>
            <div
              class="py-2 flex justify-between items-center border-b border-gray-200 pl-6 bg-gray-200"
            >
              <div class="pl-2 flex content-center">
                <div class="text-lg pr-2 text-base text-purple-700">
                  <slot name="header-icon"> <i class="fas fa-plus"></i></slot>
                </div>

                <div class="font-bold text-base pl-2">
                  <slot name="header-title">
                    Outcome Selection
                    <div class="text-xs">
                      Select custom outcomes from below.
                    </div>
                  </slot>
                </div>
              </div>

              <div class="w-32 pr-6 text-right">
                <div class="flex items-center float-right">
                  <div class="pr-6">
                    <slot name="header-action"></slot>
                  </div>
                  <button
                    class="text-sm font-semibold focus:outline-none"
                    @click="showOutcomeSelection = false"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
            <div class="p-3 pt-4 text-sm">
              <slot name="body">
                <div v-if="hasResults">
                  <div class="mb-6 max-h-screen overflow-y-auto pt-2">
                    <table
                      class="table-wrapper w-full h-full mx-auto mb-32 text-xs"
                    >
                      <tbody>
                        <tr
                          v-for="outcome in schoolOutcomes"
                          :key="outcome.identifier"
                        >
                        <td class="w-1/12 text-xs">
                          <div class="pl-2 block opacity-50">{{ parseCriteria(outcome.criteria) }}</div>
                        </td>
                          <td class="w-10/12 text-xs">
                            <span class="pl-4">{{ outcome.title }}</span>
                          </td>
                          <td class="w-1/12 -pr-2">
                            <button
                              type="button"
                              @click="selectOutcome(outcome)"
                              class="rounded-xl my-1 mr-1 w-10 h-8 cursor-pointer bg-gray-200 text-gray-600 focus:outline-none hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
                            >
                              <i
                                class="text-base far fa-circle"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot></tfoot>
                    </table>
                  </div>
                </div>
                <template v-else>
                  <p class="m-4 font-bold text-sm">
                    No custom outcomes available for course year groups.
                  </p>
                </template>
              </slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template> 

<script>
import { mapGetters } from "vuex";
const dropdown = () => import("@/components/Dropdown.vue");
const savenotice = () => import("@/components/SaveNotice.vue");
import { OutcomeService } from "@/services/outcome.service";

export default {
  name: "outcomeapply",
    props: {
    course: { type: Object, required: true },
    years: { type: Array, required: true },
    subject:  { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
    componentLoaded() {
      return this.orderedOutcomes.length > 0;
    },
    isDisabled() {
      return !this.selectedOutcomes.length > 0;
    },
    hasResults() {
      return this.privateOutcomes.length > 0;
    },
    schoolOutcomes() {
      return this.privateOutcomes.filter((item) => {
        let result = this.selectedOutcomes.find((os => os.identifier === item.identifier))
        return result === undefined  
      })
    },
    outcomeSectionsDropdown() {
      var results = [{ id: 0, name: "Showing All Sections" }].concat(
        this.sectionList
      );

      if (this.selectedTab.id === undefined) {
        this.selectedTab = results[0];
      }

      return results;
    },
    outcomeSections() {
      // let criteriaList = this.orderedOutcomes.map((o) => o.criteria);
      // let distinct = [...new Set(criteriaList)];


      // var listing = distinct
      //   .map((x) => {
      //     return x
      //       .replace("performance", "criteria_1")
      //       .replace("collaboration", "criteria_2")
      //       .replace("competition", "criteria_3");
      //   })
      //   .sort();

      // let sections = this.settings.assessmentCriteriaList.filter((a) =>
      //   listing.includes(a.key)
      // );

      // console.log("SESC", JSON.stringify(this.settings.assessmentCriteriaList) )
      // let lesson = 

      // if (sections.length === 0) {
      //   let defaultList = listing.map((x) => {
      //     return { key: x, value: x.toUpperCase() };
      //   })
      //   return defaultList.concat(lesson)
      // } else {
      //   return sections.concat(lesson)
      // }

       let sections = this.settings.assessmentCriteriaList.filter((a) => a.used ).concat([{ key: "lesson", value: "Lesson" }]  )
       if (this.selectedTab.id == undefined || this.selectedTab.id === 0) {
          return sections
       } else {
          return sections.filter((a) => a.key === this.selectedTab.id )
       }
      

    },
    orderedOutcomes() {
      let vm = this;

      let outcomesList = this.outcomes.map((object) => {
        let result = object;
        result.criteria = result.criteria
          .replace("performance", "criteria_1")
          .replace("collaboration", "criteria_2")
          .replace("competition", "criteria_3");
        return result;
      });

      if (this.selectedTab.id == undefined || this.selectedTab.id === 0) {
        return _.orderBy(outcomesList, ["display_order", "title"]);
      } else {
        var filtered = outcomesList.filter(function (outcome) {
          var filtered = true;

          if (vm.selectedTab.id != undefined) {
            filtered = outcome.criteria === vm.selectedTab.id;
          }

          return filtered;
        });
        return _.orderBy(filtered, ["display_order", "title"]);
      }
    },
    criteriaList() {
      if (this.settings.assessmentCriteriaList.length > 0) {
        return this.settings.assessmentCriteriaList;
      }
    },
    criteriaDropdown() {
      var results = [{ value: 0, name: "Criteria" }].concat(this.criteriaList);
      this.selectedCriteria = results[0];
      return results;
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      selectedCriteria: {},
      outcomes: [],
      selectedOutcomes: [],
      privateOutcomes: [],
      selectedTab: {},
      sectionList: [],
      newValues: [],
      showOutcomeSelection: false,
    };
  },
  created() {
    this.fetchCourseOutcomes();
  },
  mounted() {},
  methods: {
    fetchCourseOutcomes() {
      let withIncludes = true;
      OutcomeService.getByCourse(
        this.course.id,
        this.settings.outcomes,
        withIncludes
      )
        .then((response) => {
          this.outcomes = response.data.data;
          this.fetchSchoolData();
        })
        .catch((err) => {
          console.log("Outcomes " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    fetchSchoolData() {
   OutcomeService.getPrivate(this.subject.id)
        .then((response) => this.buildOutcomeList(response.data.data))
        .catch((err) => {
          console.log("Outcomes " + err);
          this.errored = true;
        });
    },
    buildOutcomeList(data) {
      let vm = this;
      this.sectionList = this.outcomeSections.map((element) => {
        return { id: element.key, name: element.value };
      });
   //   this.sectionList.push({ id: "lesson", name: "LESSON"} )

      this.privateOutcomes = data.filter((outcome) => {
        if (outcome.years === undefined || outcome.unit_only === 0) {
          return;
        }
        return outcome.years.find((y) => y.id === vm.course.year_id);
      });

      vm.selectedOutcomes = this.privateOutcomes
        .flatMap((outcome) => {
          if (outcome.courses === undefined) {
            return null;
          }
          if (outcome.courses.find((u) => u.id === vm.course.id)) {
            return outcome;
          } else {
            return null;
          }
        })
        .filter((element) => {
          return element !== null;
        });
    },
    outcomesOrderedBySection(key) {
      
      return this.orderedOutcomes.filter((o) => o.criteria === key);
    },
    outcomesOrderedBySectionCount(section) {
      return this.outcomesOrderedBySection(section.key).length;
    },
    getSectionTitle(section) {
      return section;
    },
    updateSelectedTab(tab) {
      this.selectedTab = tab;
    },
    addOutcomeFromText(section) {
      let object = this.newValues.find((p) => p.key === section.key);
      if (object === undefined || object.value.length <= 3) {
        return;
      }
      let typeId = this.isContentAdmin ? 1 : this.currentUser.typeID;

      let payload = {
        title: object.value,
        criteria: section.key,
        unit_only: 1,
        type_id: typeId,
        active: 1,
        years: [{ id: this.course.year_id }],
        courses: [{ course_id: this.course.id }],
        display_order: this.outcomesOrderedBySectionCount(section),
        identifier: undefined,
      };

      // add new
      let vm = this;
      OutcomeService.add(payload)
        .then((response) => {
          console.log("ADDDED");
          vm.fetchCourseOutcomes();
        })
        .catch((err) => {
          console.log("Outcome add error " + err);
        });
    },
    addNewValue(section, value) {
      let object = this.newValues.find((p) => p.key === section.key);

      if (object) {
        object.value = value;
      } else {
        this.newValues.push({ key: section.key, value: value });
      }
    },
    addCustomeOutcome(section) {
      this.showOutcomeSelection = true;
    },
    processOutcome(element) {
      let vm = this;
      OutcomeService.update(element, element.identifier)
        .then((response) => {
          vm.fetchCourseOutcomes();
        })
        .catch((err) => {
          console.log("Outcome update error " + err);
        });
    },
    criteriaSelect(criteria) {
      this.selectedCriteria = criteria;
    },
    isSchoolType(course) {
      return (
        course.type_id === 3 ||
        (course.type != undefined && course.type.id === 3)
      );
    },
    containsOutcome(outcome) {
      if (
        this.selectedOutcomes.find(
          (item) => item.identifier === outcome.identifier
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectOutcome(outcome) {
      let result = this.containsOutcome(outcome);
      if (result === true) {
        this.selectedOutcomes.splice(
          this.selectedOutcomes.findIndex(
            (item) => item.identifier === outcome.identifier
          ),
          1
        );
        outcome.courses = [];
        this.processOutcome(outcome);
      } else {
        this.selectedOutcomes.push(outcome);
        outcome.courses = [{ course_id: this.course.id }];
        this.processOutcome(outcome);
      }
    },
    parseCriteria(val) {
      let outcomeCriteria = val
        .replace("performance", "criteria_1")
        .replace("collaboration", "criteria_2")
        .replace("competition", "criteria_3");

      let ct = this.settings.assessmentCriteriaList
        .filter((criteria) => {
          return outcomeCriteria === criteria.key;
        })
        .shift();
      return ct == undefined ? "N/A" : ct.value;
    },
  },
  components: {
    dropdown,
    savenotice,
  },
};
</script>


<style scoped>
table td {
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
}

.slide-content {
  padding: 0px !important;
}

.slideinsecond {
  min-width: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0);
  height: 100%;
}

.slidesecond-enter-active {
  transition: all 0.85s ease-out;
}

.slidesecond-leave-active {
  transition: all 0.45s ease-out;
}
.slide-econd-enter-to {
  right: 0;
}
.slidesecond-enter-from {
  right: -100%;
}
.slidesecond-leave-to {
  right: -100%;
}
.slidesecond-leave-from {
  right: 0;
}

.slidesecond-leave-active,
.slidesecond-enter-active {
  transition: 0.4s ease;
}

.slidesecond-enter {
  transform: translate(100%, 0);
}
.slidesecond-leave-to {
  transform: translate(-100%, 0);
}

.sidesecond {
  z-index: 101;
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;
  height: 100%;
  opacity: 1 !important;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}
</style>
